export const LeadSourcesColumns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "leadSource", headerName: "Lead Source", flex: 1 },
];

export const LeadStatusColumns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "leadStatus", headerName: "Lead Status", flex: 1 },
];